import { Theme, css } from '@emotion/react';

export const paymentStack = (theme: Theme) => css`
  margin: ${theme.spacing(1.5)}px 0px;
`;

export const loadingContainer = (theme: Theme) => css`
  margin-top: ${theme.spacing(5)}px;
`;
